import apiRoutes from '../constants/apiRoutes';
import baseApi from '../services/api';

export enum PendingSignupStatus {
  ONBOARDING_ELIGIBLE = 'ONBOARDING_ELIGIBLE',
  COMPANY_CREATION_REQUESTED = 'COMPANY_CREATION_REQUESTED',
  COMPANY_ACCESS_REQUESTED = 'COMPANY_ACCESS_REQUESTED',
}

export interface PendingSignupMatchedCompany {
  clientCode: string;
  companyId: string;
  companyName: string;
}

export interface PendingSignupItem {
  pendingSignupId: string;
  email: string;
  username: string;
  emailDomain: string;
  status: PendingSignupStatus;
  signedUpAt: string;
  updatedAt: string;
  joiningDate: string;
  intendedCompanyName: string;
  matchedCompany: PendingSignupMatchedCompany | null;
  createCompanyRequestSubmitted: boolean;
}

export interface PendingSignupsListingRequest {
  page: number;
  size: number;
  search?: string;
  status?: PendingSignupStatus;
  matchedClientCode?: string;
  createCompanyRequestSubmitted?: boolean;
  sort?: string;
  sortOrder?: 'ASC' | 'DESC';
}

export interface PendingSignupsResponse {
  code: number;
  message: string;
  data: {
    totalPages: number;
    totalElements: number;
    items: PendingSignupItem[];
  };
}

const pendingSignupsApi = baseApi.injectEndpoints({
  endpoints: (builder) => ({
    getPendingSignups: builder.query<PendingSignupsResponse, PendingSignupsListingRequest>({
      query: ({
        page,
        size,
        search,
        status,
        matchedClientCode,
        createCompanyRequestSubmitted,
        sort,
        sortOrder,
      }) => {
        const params = new URLSearchParams();
        params.set('pageNumber', String(page));
        params.set('pageSize', String(size));

        if (search) params.set('search', search);
        if (status) params.set('status', status);
        if (matchedClientCode) params.set('matchedClientCode', matchedClientCode);
        if (createCompanyRequestSubmitted !== undefined) {
          params.set('createCompanyRequestSubmitted', String(createCompanyRequestSubmitted));
        }
        if (sort) params.set('sort', sort);
        if (sortOrder) params.set('sortOrder', sortOrder);

        return `${apiRoutes.pendingWorkspaceSignups}?${params.toString()}`;
      },
    }),
  }),
});

export const { useLazyGetPendingSignupsQuery } = pendingSignupsApi;
